import React from "react";

export default function LoadingMessage() {
  return (
    <div className="d-flex justify-content-start ">
      <div className="d-flex align-items-start w-100">
        <div className="bg-light rounded px-3 py-2 flex-grow-1">
          <div id="current-streaming-answer" className="text-break">
            <div className="d-inline-flex align-items-center" style={{ height: "20px" }}>
              <span style={{
                height: "4px",
                width: "4px",
                backgroundColor: "#999",
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "2px",
                animation: "typing 1.4s infinite ease-in-out",
                animationDelay: "-0.32s"
              }}></span>
              <span style={{
                height: "4px",
                width: "4px",
                backgroundColor: "#999",
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "2px",
                animation: "typing 1.4s infinite ease-in-out",
                animationDelay: "-0.16s"
              }}></span>
              <span style={{
                height: "4px",
                width: "4px",
                backgroundColor: "#999",
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "2px",
                animation: "typing 1.4s infinite ease-in-out"
              }}></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

